export enum BonusWalletStatusType {
  ACTIVE = '1',
  RELEASED = '2', // the wallet was complete and the balance moved to the real balance
  USEDUP = '3', // the player loses the bonus
  CANCELED = '4', // canceled either by the player o by the admin
  EXPIRED = '5', // the bonus has reached the expiration date
}
